import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import OnboardingTrackerPageUI from './OnboardingTrackerPageUI'

class OnboardingTrackerPageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            account: null,
            loading: true,
            events: [],
            error: null,
            expandedRowId: null,
            dropdownData: [],
            dropdownLoading: false,
            dropdownError: null
        }
    }

    componentDidMount() {
        let context = this.props.context
        this.getAccount(context)
    }

    getAccount(context) {
        let cacheManager = new CacheManager({
            resource: `/api/su/accounts/${this.props.match.params.accountId}`,
            cacheKey: CacheKeys.Account(this.props.match.params.accountId),
            callback: this.getAccountCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }

    getAccountCallback = (response) => {
        const account = response.account
        this.setState({ account: account })
        this.getEvents(this.props.context)
    }

    getEvents = (context) => {
        const accountId = this.props.match.params.accountId
        this.setState({ loading: true })

        // API Call to get list of events
        RestApiUtils.get(
            context,
            `/api/notify-onboarding-event-tracker/getByAccountId/${accountId}`,
            this.handleEventsResponse,
            this.handleEventsError
        )
    }

    handleEventsResponse = (response) => {
        // Check if entities array exists in response
        if (response && response.entities) {
            this.setState({
                events: response.entities,
                loading: false,
                error: null
            })
        } else {
            // Handle case where success might be null but no entities
            this.setState({
                events: [],
                loading: false,
                error: null
            })
        }
    }

    handleEventsError = (error) => {
        console.error('Error getting events:', error)
        this.setState({
            loading: false,
            error: 'Failed to load events. Please try again later.'
        })
    }

    onRefreshClick = () => {
        this.getAccount(this.props.context)
    }

    handleExpandRow = (event) => {
        // Toggle logic
        const isSameRow = this.state.expandedRowId === event.sessionId // using sessionId as unique key based on sample response

        if (isSameRow) {
            this.setState({ expandedRowId: null, dropdownData: [] })
        } else {
            this.setState({
                expandedRowId: event.sessionId,
                dropdownLoading: true,
                dropdownError: null,
                dropdownData: []
            }, () => {
                this.getDropdownData(event)
            })
        }
    }

    getDropdownData = (event) => {
        const { sessionId } = event

        const url = `/api/v1/notify-event-tracker/onboarding?sessionId=${sessionId}`

        RestApiUtils.get(
            this.props.context,
            url,
            this.handleDropdownResponse,
            this.handleDropdownError
        )
    }

    handleDropdownResponse = (response) => {
        const dropdownData = response && (response.eventTrackers || response.entities)
        if (dropdownData) {
            this.setState({
                dropdownData: dropdownData,
                dropdownLoading: false
            })
        } else {
            this.setState({
                dropdownData: [],
                dropdownLoading: false
            })
        }
    }

    handleDropdownError = (error) => {
        console.error('Error getting dropdown data:', error)
        this.setState({
            dropdownLoading: false,
            dropdownError: 'Failed to load details.'
        })
    }

    render() {
        return (
            <OnboardingTrackerPageUI
                context={this.props.context}
                account={this.state.account}
                events={this.state.events}
                loading={this.state.loading}
                error={this.state.error}
                onRefreshClick={this.onRefreshClick}
                expandedRowId={this.state.expandedRowId}
                onExpandRow={this.handleExpandRow}
                dropdownData={this.state.dropdownData}
                dropdownLoading={this.state.dropdownLoading}
                dropdownError={this.state.dropdownError}
            />
        )
    }
}

export default withRouter(OnboardingTrackerPageSF)
